import React from 'react';
import ReactDOM from 'react-dom/client';
import mapboxgl from 'mapbox-gl';
import './index.css';
import SignIn from './SignIn';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { setMapboxToken, setGoogleClientId, getGoogleClientId, setLiveSimulation, setDemoMetro } from './config';
import { installAuth } from './utils/auth';


// Before anything can issue a request: this attaches the session token to every
// same-origin /api call (axios and fetch alike) and turns a 401 into a trip back
// to the sign-in page.
installAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));

function render() {
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={getGoogleClientId()}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  );
}

// The Mapbox token and Google client id come from the backend, so both must be in
// place before any map or GoogleOAuthProvider mounts — hence fetch-then-render.
// A failure still renders the app.
fetch('/api/config')
  .then((r) => r.json())
  .then((cfg) => {
    setMapboxToken(cfg.mapboxToken);
    mapboxgl.accessToken = cfg.mapboxToken;
    setGoogleClientId(cfg.googleClientId);
    setLiveSimulation(cfg.liveSimulation);
    setDemoMetro(cfg.demoMetro);
  })
  .catch((err) => {
    console.error('Could not load /api/config; maps will not render.', err);
  })
  .finally(render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
